































































import { GENERATE_S3_URL } from "@/queries/user/mutation.graphql";
import Vue from "vue";
export default Vue.extend({
  props: {
    image: {
      type: String
    },
    label: {
      type: String,
      default: "Photo"
    },
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      img: null,
      uploadOrEditEvent: null,
      mode: null
    };
  },
  methods: {
    async uploadImg(e: Event) {
      const input: HTMLInputElement = e.target as HTMLInputElement;
      if (input.files && input.files[0]) {
        const imgFile = input.files[0];
        const formData = new FormData();
        const { data, errors } = await this.$apollo.mutate({
          mutation: GENERATE_S3_URL,
          variables: {
            fileName: imgFile.name
          }
        });

        if (errors) {
          return;
        }

        if (data && data.generateS3UploadUrl) {
          const file = new File([imgFile], imgFile.name, {
            type: imgFile.type
          });
          const url = data.generateS3UploadUrl.uploadUrl;

          await fetch(url, {
            method: "PUT",
            body: file,
            headers: { "Content-Type": file.type }
          });

          const imgUrl = url.split("?")[0];

          this.$emit(this.mode, imgUrl);
          this.mode = null;
        }

        // const reader = new FileReader();
        // reader.onload = (e: ProgressEvent) => {
        //   this.img = (e.target as FileReader).result;
        //   this.$emit(this.mode, this.img);
        //   this.mode = null;
        // };
        // reader.readAsDataURL(input.files[0]);
      }
    },
    replace() {
      this.mode = "replaceImage";
      (this.$refs.uploader as HTMLLabelElement).click();
    },
    setUploadMode() {
      if (!this.mode) {
        this.mode = "uploadImage";
      }
    }
  }
});
